import { MutationTree } from 'vuex';
import { IChatState, EChatMutation } from '@/dealroom-view/chat/store/chat.types';
import { IComment } from '@/dealroom-view/chat/types/comment';

export const mutations: MutationTree<IChatState> = {
  [EChatMutation.SetComments](state: IChatState, comments: IComment[]) {
    state.comments = comments;
  },
  [EChatMutation.SetCommentsRead](state: IChatState, commentsRead: IComment[]) {
    state.commentsRead = commentsRead;
  },
  [EChatMutation.SetLoaded](state: IChatState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EChatMutation.SetState](state: IChatState, newState: IChatState) {
    state.comments = newState.comments;
    state.commentsRead = newState.commentsRead;
    state.loaded = newState.loaded;
  },
};
